import { fetcher } from "utils";

export const get__members__order_product_contacts__new = (): Promise<{ typeof: string[] }> =>
  fetcher.get("/members/order_product_contacts/new");
